export const ADMIN = "Admin"